var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left d-flex align-center mt-2 flex-wrap"},_vm._l((_vm.hitPointsMap),function(ref,index){
var hitPoints = ref.hitPoints;
var hpIndex = ref.hpIndex;
return _c('MySelect',{key:hpIndex,staticClass:"mb-3 mr-3",class:_vm.$style.hitPoints,attrs:{"value":hitPoints,"items":_vm.range(1, _vm.maxValue),"hide-details":"","outlined":"","disabled":hpIndex === -1},on:{"change":function (newValue) { return _vm.handleUpdate(newValue, hpIndex); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }